import React from 'react';
import { Button, Col, Row } from 'antd';
import { NoteAvatar } from './NoteAvatar';
import styles from './notes.module.sass';
import { EditOutlined } from '@ant-design/icons';

export function NoteHeader({
  noteUUID,
  noteDescription,
  fullName,
  setEditModalVisibility,
  isMine,
  createdAt,
  idx,
}) {
  let dateAdded = createdAt?.split('T')?.[0];
  let style = {};
  if (idx > 0) {
    style = {
      paddingTop: 16,
      borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    };
  }
  return (
    <div style={style} className={styles['notes-header-container']}>
      <div className={styles['notes-header-avatar-section']}>
        <NoteAvatar
          style={{
            width: 32,
            height: 32,
            fontSize: 14,
          }}
          fullName={fullName}
          isMine={isMine}
        />
      </div>
      <div className={styles['notes-header-name-date-section']}>
        <span className={styles['notes-header-name']}>{fullName}</span>
        <span className={styles['notes-header-date-added']}>
          Note added on {dateAdded}
        </span>
      </div>
      {isMine && (
        <div className={styles['notes-header-edit-button']}>
          <Button
            type="primary"
            style={{
              border: 0,
              color: 'white',
              boxShadow: 'none',
            }}
            shape="round"
            onClick={() =>
              setEditModalVisibility({
                visibility: true,
                description: noteDescription,
                uuid: noteUUID,
              })
            }
            icon={<EditOutlined />}
            ghost
          />
        </div>
      )}
    </div>
  );
}
